import { render, staticRenderFns } from "./RealEstateItemCard.vue?vue&type=template&id=0541c50a&"
import script from "./RealEstateItemCard.vue?vue&type=script&lang=js&"
export * from "./RealEstateItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports